<template>
  <div id="app">
   <md-progress-bar md-mode="indeterminate" v-show="isLoading"></md-progress-bar>    
   <div class="containerg">
     
    <transition>
      <router-view></router-view>
    </transition>

   </div>
  </div>
</template>

<script>

import eventBus from './bus'

export default {
  name: 'App',
  data: () => ({
    isLoading:true
  }), 
  created(){
    var that = this
    eventBus.$on('isLoading',(data)=>{
      that.isLoading = data
    })
  } 
}
</script>

<style>
@import "../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../node_modules/@syncfusion/ej2-vue-inputs/styles/material.css";

@import '../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import "../node_modules/@syncfusion/ej2-vue-calendars/styles/material.css";

#app {
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>
